import { PictureOutlined } from "@ant-design/icons";
import { logoCore } from "./core/logo";
import { defineWidget } from "../widgetDefinition";
import { NoSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { LogoComponentSpec } from "../Processing/types";
import { LogoWidget } from "../WidgetComponents/LogoWidget";
import { LogoConfigurator } from "../AddWidgetModal/LogoConfigurator";

export const logoDefinition = defineWidget<LogoComponentSpec>({
  ...logoCore,
  type: "logo",
  slots: NoSlots,
  duplicate: NoDuplication,
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: ["display"],
  contractHash: "0qtls4s73v5",

  template: {
    label: "Logo",
    description: "Team badge or branding placeholder",
    icon: <PictureOutlined />,
  },

  defaultLayout: { w: 3, h: 6, minW: 1, minH: 2 },

  gridComponent: ({ id }) => <LogoWidget id={id} />,

  configurator: {
    modalTitle: "Logo Widget",
    wide: false,
    Component: LogoConfigurator as any,
  },
});
